module.exports = __webpack_public_path__ + "img/headshot-daniela-escobar@2x.cc415dd0.jpg";